const config = {
  apiKey: "AIzaSyDdHN_CwKHElHq7waSSn-u_ykfWJi2BG4g",
  authDomain: "abhishekcdesign.firebaseapp.com",
  databaseURL: "https://abhishekcdesign.firebaseio.com",
};

export default config;
